import * as React from "react"
import { useMatches, Link } from "react-router"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import type { RouteHandle } from "@/types/react-router"

export function Breadcrumbs() {
  const matches = useMatches()

  // Filter routes that have breadcrumb metadata
  const breadcrumbs = matches
    .filter((match) => {
      const handle = match.handle as RouteHandle | undefined
      return handle?.breadcrumb
    })
    .map((match) => {
      const handle = match.handle as RouteHandle
      // Type assertion needed because useMatches returns UIMatch<unknown, unknown>
      const typedMatch = match as any
      return {
        pathname: match.pathname,
        breadcrumb: handle.breadcrumb!(typedMatch),
      }
    })

  // Don't render if only one breadcrumb (Dashboard at root)
  if (breadcrumbs.length <= 1) {
    return null
  }

  return (
    <Breadcrumb className="mb-4">
      <BreadcrumbList>
        {/* Always show Home as first item */}
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/">Home</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1

          return (
            <React.Fragment key={breadcrumb.pathname}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{breadcrumb.breadcrumb}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={breadcrumb.pathname}>{breadcrumb.breadcrumb}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
